import React from 'react'

/**
 * Estado vacío de marca: ícono sobre un círculo azul con una mancha amarilla detrás,
 * título, una línea que explica qué hacer y acciones. `children` va debajo (p. ej.
 * accesos secundarios).
 */
export default function EstadoVacio({ icon, titulo, texto, acciones, children }) {
    return (
        <section className="relative overflow-hidden rounded-3xl bg-white border border-gray-100 shadow-[0_1px_3px_rgba(0,0,0,.05),0_8px_32px_-12px_rgba(0,0,0,.08)]">
            {/* Franja amarilla superior */}
            <div aria-hidden className="h-1.5 bg-secondary" />
            {/* Patrón de puntos muy sutil */}
            <div aria-hidden className="absolute inset-0 opacity-[.35] pointer-events-none" style={{
                backgroundImage: 'radial-gradient(circle, #e6eefb 1.2px, transparent 1.2px)',
                backgroundSize: '22px 22px',
                maskImage: 'radial-gradient(ellipse at center, #000 20%, transparent 70%)',
                WebkitMaskImage: 'radial-gradient(ellipse at center, #000 20%, transparent 70%)',
            }} />

            <div className="relative flex flex-col items-center text-center px-6 py-14 sm:py-16">
                <div className="relative mb-7">
                    <span aria-hidden className="absolute -right-3 -top-2 w-16 h-16 rounded-full bg-secondary/70" />
                    <div className="relative w-24 h-24 rounded-full bg-primary text-white flex items-center justify-center text-[40px] shadow-[0_12px_28px_-8px_rgba(0,71,187,.6)]">
                        {icon}
                    </div>
                </div>

                <h2 className="text-2xl sm:text-[28px] font-extrabold text-gray-900 mb-2">{titulo}</h2>
                {texto && <p className="text-gray-500 max-w-md leading-relaxed mb-7">{texto}</p>}
                {acciones && <div className="flex flex-wrap justify-center gap-3">{acciones}</div>}
                {children}
            </div>
        </section>
    )
}

/* Botones con el estilo del home, para usar dentro de `acciones`. */
export const claseBotonPrimario =
    'inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary text-white font-bold text-sm shadow-sm hover:brightness-110 active:scale-[.98] transition-all'
export const claseBotonSecundario =
    'inline-flex items-center gap-2 px-6 py-3 rounded-full border border-gray-200 bg-white text-gray-700 font-semibold text-sm hover:border-primary hover:text-primary transition-all'
